import { PropertyDetails } from '@keaze/web/common/interfaces';
import { getColorFromRange, ColorType } from '../../helpers/getColorFromRange';
import { Rating } from '../../rating';
import { TableData } from './features.types';
import { DownloadButton } from '../../propertyListing/Buttons';

type UseFeaturesExpected = {
  bodyRows1: TableData[];
  bodyRows2: TableData[];
};

type UseFeatures = (propertyDetails: PropertyDetails) => UseFeaturesExpected;

export const useFeatures: UseFeatures = ({
  bedrooms,
  bathrooms,
  receptionRooms,
  furnitureStatus,
  floorArea,
  numberOfFloors,
  floor,
  tenure,
  leaseYears,
  energyEfficiencyRatingCurrent,
  energyEfficiencyRatingPotential,
  environmentalImpactRatingCurrent,
  environmentalImpactRatingPotential,
  kid,
}) => {
  const bodyRows1: TableData[] = [
    { name: 'Bedrooms', value: bedrooms },
    { name: 'Bathrooms', value: bathrooms },
    {
      name: 'Reception rooms',
      value: receptionRooms,
      hidden: receptionRooms === null,
    },
    {
      name: 'Furniture status',
      value: furnitureStatus,
      hidden: furnitureStatus === null,
    },
    { name: 'Floor area', value: floorArea, hidden: floorArea === null },
    {
      name: 'Number of floors',
      value: numberOfFloors,
      hidden: numberOfFloors === null,
    },
    {
      name: 'Entrance floor',
      value: floor !== null && floor.name,
      hidden: floor === null,
    },
  ];

  const bodyRows2: TableData[] = [
    { name: 'Tenure', value: tenure },
    {
      name: 'Lease years',
      value: leaseYears,
      hidden: leaseYears === null,
    },
    {
      name: 'EER Current',
      value: (
        <Rating
          value={Number(energyEfficiencyRatingCurrent)}
          color={getColorFromRange(
            Number(energyEfficiencyRatingCurrent),
            ColorType.EER
          )}
        />
      ),
      hidden: energyEfficiencyRatingCurrent === null,
    },
    {
      name: 'EER Potential',
      value: (
        <Rating
          value={Number(energyEfficiencyRatingPotential)}
          color={getColorFromRange(
            Number(energyEfficiencyRatingPotential),
            ColorType.EER
          )}
        />
      ),
      hidden: energyEfficiencyRatingPotential === null,
    },
    {
      name: 'EIR Current',
      value: (
        <Rating
          value={Number(environmentalImpactRatingCurrent)}
          color={getColorFromRange(
            Number(environmentalImpactRatingCurrent),
            ColorType.EIR
          )}
        />
      ),
      hidden: environmentalImpactRatingCurrent === null,
    },
    {
      name: 'EIR Potential',
      value: (
        <Rating
          value={Number(environmentalImpactRatingPotential)}
          color={getColorFromRange(
            Number(environmentalImpactRatingPotential),
            ColorType.EIR
          )}
        />
      ),
      hidden: environmentalImpactRatingPotential === null,
    },
  ];

  kid?.forEach((k, index) => {
    bodyRows2.push({
      name: `Key Information Document${
        kid.length > 1 ? ' (' + (index + 1) + ')' : ''
      }`,
      value: (
        <DownloadButton
          onClick={() => {
            window.open(k.url, '_blank', 'noreferrer');
          }}
        />
      ),
      hidden: kid === null,
    });
  });

  return {
    bodyRows1,
    bodyRows2,
  };
};
